import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/');
      return;
    }

    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const processGoogleAuth = async () => {
      try {
        const response = await axios.post('/auth/google', { session_id: sessionId });
        const user = response.data.user;
        
        localStorage.setItem('user', JSON.stringify(user));
        
        toast.success(`Welcome ${user.name}!`);
        
        if (user.role === 'creator') {
          navigate('/dashboard', { state: { user }, replace: true });
        } else {
          navigate('/', { state: { user }, replace: true });
        }
      } catch (error) {
        console.error('Auth error:', error);
        toast.error('Authentication failed');
        navigate('/', { replace: true });
      }
    };

    processGoogleAuth();
  }, [navigate, location.hash]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505]">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[#00F0FF] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-white text-lg">Authenticating...</p>
      </div>
    </div>
  );
}

export default AuthCallback;
